import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  IconButton,
  Input,
  Pagination,
  SelectPicker,
  Tag,
} from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";

import { createAPIEndpoint } from "../../API/authenticated.request";
import Grid from "../../Components/Grid";
import Responsive from "../../Components/Responsive";
import { Base_URL2 } from "../../Config/api.config";
import { height, minHeight, width } from "@mui/system";
import moment from "moment";
import Filter from "../../Components/Common/Filter";
import Swal from "sweetalert2";

const SendMessages = () => {
  //-------- States  --------//
  const [filterModel, setfilterModel] = useState({
    q: "",
    disponibilityId: 0,
    page: 1,
    take: 20000,
  });
  const [messages, setmessages] = useState({
    msg1: "",
    msg2: "",
    msg3: "",
    msg4: "",
  });
  const [style, setStyle] = useState({ background: "rgb(238, 238, 238)" });

  const [dates, setdates] = useState([]);
  const [dataCustomers, setdataCustomers] = useState([]);
  const [totalCount, settotalCount] = useState([]);
  const [inputNumber, setInputNumber] = useState("");
  const [sendTo, setsendTo] = useState([]);
  const [phoneNumbers, setphoneNumbers] = useState([]);
  //-------- Variables --------//

  //-------- Functions --------//

  const getMessages = () => {
    createAPIEndpoint("Message", filterModel)
      .fetch()
      .then((res) => setmessages(res.data.data[0]))
      .catch((err) => console.log(err));
  };
  const getDates = () => {
    createAPIEndpoint("PackageUmrah/getDates", { q: "" })
      .fetch()
      .then((res) => {
        let filteredDates = res.data.data.filter((date) =>
          filterModel.seasonId ? date.seasonId == filterModel.seasonId : date,
        );
        setdates(
          filteredDates
            .reduce(
              (accumulator, el) => accumulator.concat(el.disponibilities),
              [],
            )
            .map((el) => ({
              label: el.airline
                ? moment(el.date).format("DD/MM/YYYY") +
                  " -- " +
                  el.airline.fullName
                : "",
              value: el.id,
            })),
        );
      })
      .catch((err) => console.log(err));
  };
  const getphoneNumbers = () => {
    createAPIEndpoint("/survey/getphoneNumbers", filterModel)
      .fetch()
      .then((res) => {
        setphoneNumbers(res.data);
      })
      .catch((err) => console.log(err));
  };
  const sendMessages = () => {
    createAPIEndpoint("Message/SendCommercialMessage")
      .create(sendTo)
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputNumber.trim()) {
      e.preventDefault();
      const phone = inputNumber.trim();
      if (/^\+?\d{8}$/.test(phone)) {
        setsendTo((prev) => [...prev, phone]);
        setInputNumber("");
      } else {
        Swal.fire({
          title: "Numero incorrect",
          icon: "error",
        });
      }
    }
  };
  const removeAtIndex = (arr, i) => {
    var list = [...arr];
    if (i >= 0 && i < arr.length) {
      list.splice(i, 1);
    }
    setsendTo(list);
  };

  const reset = () => {
    setInputNumber("");
    setdataCustomers([]);
  };

  useEffect(() => {
    getDates();
    getMessages();
  }, []);
  useEffect(() => console.log(filterModel), [filterModel]);
  return (
    <div className="p-10">
      <Filter search={getphoneNumbers}>
        <Responsive className="p-10" m={5} l={5} xl={5}>
          <label htmlFor=""> Date:</label>
          <SelectPicker
            block
            data={dates}
            value={filterModel.disponibilityId}
            onChange={(disponibilityId) =>
              setfilterModel((prev) => ({
                ...prev,
                disponibilityId,
              }))
            }
          />
        </Responsive>
      </Filter>
      <Responsive className="p-10" m={5} l={5} xl={5}>
        <Input
          placeholder="Ajouter un numero "
          value={inputNumber}
          onChange={(v) => setInputNumber(v)}
          onKeyDown={handleKeyDown}
        />
      </Responsive>
      {/* <Responsive className="p-10" m={5} l={5} xl={5}>
        <Button onClick={handleKeyDown(phoneNumber)} appearance="primary">
          Ajouter
        </Button>
      </Responsive> */}

      <Responsive
        className="p-10"
        style={{ background: "white", minHeight: 250 }}
      >
        {sendTo.map((number, index) => {
          return (
            <Tag
              style={{ background: "rgb(238, 238, 238)", height: 25 }}
              closable
              onClose={() => {
                // alert("ok");
                removeAtIndex(sendTo, index);
              }}
            >
              {number}
            </Tag>
          );
        })}
      </Responsive>
      <Responsive className="p-10">
        <Button
          appearance="primary"
          style={{ float: "right", fontSize: 17 }}
          onClick={sendMessages}
        >
          Envoyer
        </Button>
      </Responsive>
      <Responsive
        className="p-10"
        style={{
          background: "white",
          minHeight: 250,
          overflowY: "scroll",
          overflowX: "hidden",
          height: 300,
        }}
      >
        {phoneNumbers.map((element, index) => {
          return (
            <IconButton
              appearance="primary"
              disabled={sendTo.includes(element) ? true : false}
              icon={
                <PlusIcon
                  style={
                    sendTo.includes(element)
                      ? { background: "green", marginRight: 5 }
                      : {
                          background: "rgb(238, 238, 238)",
                          color: "black",
                        }
                  }
                />
              }
              key={index}
              placement="right"
              style={
                sendTo.includes(element)
                  ? { background: "green", marginRight: 5, marginBottom: 5 }
                  : {
                      background: "rgb(238, 238, 238)",
                      color: "black",
                      marginRight: 5,
                      marginBottom: 5,
                    }
              }
              onClick={() => {
                var number = phoneNumbers[index];
                if (!sendTo.includes(phoneNumbers[index])) {
                  setsendTo((prev) => [...prev, number]);
                }
              }}
            >
              {element}
            </IconButton>
          );
        })}
      </Responsive>
      <div style={{ padding: 5 }}>
        <Button
          appearance="primary"
          onClick={() => {
            var numbers = [];
            phoneNumbers.forEach((phoneNumber) => {
              console.log(phoneNumber);
              if (!sendTo.includes(phoneNumber)) {
                numbers = [...numbers, phoneNumber];
              }
            });
            setsendTo((prev) => [...prev, ...numbers]);
          }}
          color="white"
          style={{ float: "right" }}
        >
          Select All
        </Button>
      </div>
    </div>
  );
};

export default SendMessages;
